/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyAcceptCodeLabelTypename = "PharmacyAcceptCodeLabel" as const;

/**
 *
 * @export
 * @interface PharmacyAcceptCodeLabel
 */
export interface PharmacyAcceptCodeLabel {
  /**
   *
   * @type {string}
   * @memberof PharmacyAcceptCodeLabel
   */
  acceptCodeLaneType: PharmacyAcceptCodeLabelAcceptCodeLaneTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyAcceptCodeLabel
   */
  label: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyAcceptCodeLabel
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyAcceptCodeLabelAcceptCodeLaneTypeEnum {
  Normal = "normal",
  Quick = "quick",
}

export function PharmacyAcceptCodeLabelFromJSON(json: any): PharmacyAcceptCodeLabel {
  return PharmacyAcceptCodeLabelFromJSONTyped(json, false);
}

export function PharmacyAcceptCodeLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyAcceptCodeLabel {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyAcceptCodeLabelTypename,

    acceptCodeLaneType: json["accept_code_lane_type"],
    label: json["label"],
  };
}

export function PharmacyAcceptCodeLabelToJSON(object?: PharmacyAcceptCodeLabel | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    accept_code_lane_type: value.acceptCodeLaneType,
    label: value.label,
  };
}
